export const RUN_RESULTS = {
  PENDING: "PENDING",
  PASSED: "PASSED",
  FAILED: "FAILED",
  STALE: "STALE",
} as const;

export default RUN_RESULTS;
